import { render } from 'solid-js/web';
import '98.css/dist/98.css';
import './styles/app.css';
import App from './App';
import { applyPreferences, readPreferences } from './lib/preferences';

applyPreferences(readPreferences());

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

render(() => <App />, root);
